import { render } from "./VeeBranchesDropdown.vue?vue&type=template&id=0a10c06f"
import script from "./VeeBranchesDropdown.vue?vue&type=script&lang=js"
export * from "./VeeBranchesDropdown.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__